export default "__VITE_ASSET__DZSh6_sX__"